import styled from "@emotion/styled"
import { Button } from "@tmu/components/common"

export const StyledBlogJoiningContainer = styled.div`
  display: grid;
  grid-column: 1fr;
  grid-gap: 1rem;
  margin: 1rem 0 3.5rem;
  padding: 0 1rem;
   img {
      margin: 0 auto;
      padding: 0;
      width: 90%;
      height: auto;
    }
  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 40px 130px 1fr;
    grid-auto-flow: column;
    margin: 2.5rem 1rem;
    grid-gap: 0 1rem;

    margin: 1rem auto 3.5rem;
    padding: 0 1.5rem;
    max-width: ${(p) => p.theme.breakpoints.tablet};

    img {
      margin: 0;
      padding: 0;
      width: 100%;
      height: auto;
    }
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
    padding: 0 2rem;
    grid-gap: 0 1.5rem;
    max-width: ${(p) => p.theme.breakpoints.desktop};
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    grid-gap: 1rem 2rem;
    margin: 2rem auto 5rem;
    padding: 0 6rem;
    grid-gap: 0 2rem;
    max-width: ${(p) => p.theme.breakpoints.wide};
  }
`

export const StyledBlogTitle = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-style: ${(p) => p.theme.fontStyles.normal};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: center;
  color: ${(p) => p.theme.colors.blue};

  &.mh-3 {
    margin-top: 3rem;
    color: ${(p) => p.theme.colors.black};
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 2rem;
    line-height: 2.625rem;
  }
`

export const StyledBlogContent = styled.div`
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  font-style: ${(p) => p.theme.fontStyles.normal};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 0.75rem;
  line-height: 1.125rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1rem;
    line-height: 1.375rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
`

export const StyledBlogButton = styled(Button)`
  span {
    font-family: ${(p) => p.theme.fontFamilies.headline};
    font-weight: ${(p) => p.theme.fontWeights.semiBolder};
    font-style: ${(p) => p.theme.fontStyles.normal};
    color: ${(p) => p.theme.colors.blue};
  }

  font-size: 1rem;
  line-height: 1.5rem;
  height: fit-content;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-top: 0;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    p {
      font-size: 1.25rem;
    }
  }
`

export const StyledJoining = styled.div`
  display: grid;
  grid-template-rows: repeat(3, 1fr);

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
  }
`

export const StyledJoiningTitle = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-style: ${(p) => p.theme.fontStyles.normal};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 1rem;
  line-height: 1.5rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 2rem;
    line-height: 2.625rem;
  }
`

export const StyledJoiningContent = styled.div`
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  font-style: ${(p) => p.theme.fontStyles.normal};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 0.75rem;
  line-height: 1.125rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: 1rem;
    line-height: 1.375rem;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
`

export const StyledJoiningButton = styled(Button)`
  span {
    font-family: ${(p) => p.theme.fontFamilies.headline};
    font-weight: ${(p) => p.theme.fontWeights.semiBolder};
    font-style: ${(p) => p.theme.fontStyles.normal};
    color: ${(p) => p.theme.colors.blue};
  }

  font-size: 1rem;
  line-height: 1.5rem;
  height: fit-content;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-top: 0;
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.desktop}) {
  }

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    p {
      font-size: 1.25rem;
    }
  }
`
